export default __webpack_public_path__ + "images/marker.0d68af28f92f382d219ef3c3b3408578.png";